import React, {Component} from "react";
import {Container} from "reactstrap";
import {MetaTags} from "react-meta-tags";

export class Terms extends Component {
  render() {
    return (
      <Container style={{marginTop: "50px"}}>
        <MetaTags>
          <title>RiasBot - Terms of Service</title>
        </MetaTags>
        <h1 style={{color: "#DC143C", marginBottom: "30px"}}>Terms of Service</h1>
        <p>By inviting Rias Bot (ID 831993597166747679) in your server and by using it, you agree with the following terms and rules.</p>
        <p>Any violation will issue you a warning or remove your access to the bot and your data on it to be removed.</p>
        <br/>
        <h4 style={{color: "#DC143C"}}>Selfbot Activity</h4>
        <p>Selfbotting with the intention of farming XP or hearts is prohibited and may result in an immediate reset or bot ban. This also includes auto-typers, macros or anything that enables the automation of commands.</p>
        <br/>
        <h4 style={{color: "#DC143C"}}>Alternative Accounts</h4>
        <p>There may be a case where your main account cannot be accessed anymore and you request for your data to be moved to another account you own. You will be verified on this action to assure that you are the owner of the alternative account.</p>
        <br/>
        <h4 style={{color: "#DC143C"}}>Exploits</h4>
        <p>
          Do not try to exploit the commands to gain more xp or hearts and do not try to bypass the banned words of the NSFW commands.
          If you found an exploit, report it immediately.
        </p>
        <br/>
        <h4 style={{color: "#DC143C"}}>Copyright</h4>
        <p>The source code of the project is open under MIT license and you may copy or modify it but do not to impersonate the bot.</p>

        <p>These terms can be changed at any moment and this action will be notified to the users.</p>
      </Container>
    )
  }
}